// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5938":"7f4e1585","9001":"7f4e1585"}[chunkId] + ".chunk.css";
};